module.exports = __webpack_public_path__ + "img/table-vectometer.9dd4394d.svg";